import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Delivery',
    pickup: 'Pickup',
    room_service: 'On site',
    table_service: 'On site',
  },
  asap: 'ASAP',
  unavailable: 'Unavailable',
  ready_in_time: 'Ready in {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Delivery to {{address}}',
    [ORDER_METHODS.PICKUP]: 'Pickup at {{address}}',
    [ORDER_METHODS.ROOM_SERVICE]: 'On site at {{address}}',
  },
  buttons: {
    change: 'Change',
    see_hours: 'See hours',
    change_location: 'Change location',
    change_time: 'Change time',
  },
};
